module.exports = __webpack_public_path__ + "img/defaultImg.d8ddc3c8.png";